var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.961,
    height: 52.597,
    viewBox: "0 0 59.961 52.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 59.961,
    height: 52.597,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_350",
    "data-name": "Groupe 350",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2842",
    "data-name": "Trac\\xE9 2842",
    d: "M0,19.668c.21-1.182.338-2.387.647-3.543a20.542,20.542,0,0,1,9.588-12.6A24.172,24.172,0,0,1,37.918,5.312c.594.473,1.112,1.038,1.7,1.515a2.035,2.035,0,0,0,.9.435c7.824,1.285,13.916,5.131,17.4,12.372,3.208,6.662,2.546,13.226-1.412,19.455a1.219,1.219,0,0,0-.172,1.169c1.076,3.291,2.118,6.594,3.163,9.895a1.722,1.722,0,0,1-1.195,2.422,2.5,2.5,0,0,1-1.441-.253q-4.813-2.387-9.581-4.861a1.337,1.337,0,0,0-1.2-.047c-8.683,3.146-16.752,2.091-24.134-3.571a7.962,7.962,0,0,1-1.263-1.127,3.085,3.085,0,0,0-1.851-.943c-1.739-.4-3.454-.911-5.164-1.424a1.188,1.188,0,0,0-.981.045c-3.222,1.65-6.444,3.3-9.684,4.913a2.477,2.477,0,0,1-1.387.262A1.715,1.715,0,0,1,.369,43.18q1.582-5.009,3.2-10.007A1.029,1.029,0,0,0,3.43,32.16,19.42,19.42,0,0,1,.1,23.042a3.392,3.392,0,0,0-.1-.45V19.668M54.912,47.4c-.072-.264-.111-.429-.163-.591-.682-2.151-1.332-4.313-2.063-6.446a2.508,2.508,0,0,1,.428-2.546,16.111,16.111,0,0,0-.153-19.663,19.094,19.094,0,0,0-14.222-7.522,19.521,19.521,0,0,0-15.882,5.646,15.808,15.808,0,0,0-4.829,14.473,16.673,16.673,0,0,0,8.6,12.045,20.355,20.355,0,0,0,18.961,1.015,2.535,2.535,0,0,1,2.386.057c1.557.842,3.15,1.619,4.729,2.42.7.358,1.41.71,2.207,1.112m-38.29-9.669.087-.122c-.086-.173-.174-.346-.259-.519a19.129,19.129,0,0,1,.073-18.079C19.853,12.622,25.337,9.006,32.3,7.506c.692-.15,1.4-.238,2.209-.374-.337-.227-.57-.4-.815-.546a20.158,20.158,0,0,0-9.068-2.969A19.905,19.905,0,0,0,9.864,8.1,16.351,16.351,0,0,0,3.525,21.553a15.7,15.7,0,0,0,3.327,9.362A2.287,2.287,0,0,1,7.244,33.2c-.712,2.141-1.384,4.3-2.07,6.445-.068.215-.115.437-.192.731.326-.159.57-.274.811-.4,2.1-1.068,4.2-2.127,6.292-3.21a2.149,2.149,0,0,1,2.01-.053c.826.374,1.683.68,2.528,1.015",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2843",
    "data-name": "Trac\\xE9 2843",
    d: "M37.966,37.316a1.753,1.753,0,1,1,1.73-1.761,1.773,1.773,0,0,1-1.73,1.761",
    transform: "translate(-8.001 -7.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2844",
    "data-name": "Trac\\xE9 2844",
    d: "M57.716,35.56a1.752,1.752,0,1,1-1.742-1.748,1.775,1.775,0,0,1,1.742,1.748",
    transform: "translate(-11.985 -7.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2845",
    "data-name": "Trac\\xE9 2845",
    d: "M48.706,35.572a1.752,1.752,0,1,1-1.729-1.761,1.774,1.774,0,0,1,1.729,1.761",
    transform: "translate(-9.993 -7.475)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkingIcon);
export default __webpack_public_path__ + "static/media/networking-icon.1893b432921ddb31b2ea07e7cbc9f034.svg";
export { ForwardRef as ReactComponent };